import { SATError, SATErrorType, SATResult } from "@sadtx/sat-error";

export function safeMapToEntity<T, U>(
  value: T | undefined | null,
  mapper: (value: T) => U,
  errorContext: string,
): SATResult<U, SATError> {
  try {
    if (value == null) {
      return SATResult.failure(
        new SATError(
          SATErrorType.FailConvertDtoToEntityError,
          `[safeMapToEntity] :: ${errorContext} :: value is null or undefined`,
        ),
      );
    }

    return SATResult.success(mapper(value));
  } catch (error) {
    console.error("[safeMapToEntity] :: Mapper 오류", { errorContext, error });
    return SATResult.failure(
      new SATError(
        SATErrorType.FailConvertDtoToEntityError,
        error instanceof Error ? error.message : String(error),
      ),
    );
  }
}
